import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Position } from '@xyflow/react';
import Checkbox from '@mui/material/Checkbox';
import { FormControlLabel, Stack } from '@mui/material';
import { useGetAiModelsByProviderIdQuery, useGetAiProvidersQuery } from 'services/aiProviderApi';
import { BaseNode } from 'pages/assistants/builder/components/nodes/baseNode';
import { CompactNodeField } from 'pages/assistants/builder/components/nodes/compactNodeField';

export function LongContextModelNode({ id, data, onEditNode, onDeleteNode }) {
  const { formatMessage: msg } = useIntl();
  const { providerCode, modelCode, outputVar } = data;

  const { data: providers = [] } = useGetAiProvidersQuery();
  const filteredProviders = providers.filter((p) => p.displayableKey !== '***********');
  const selectedProvider = filteredProviders.find((p) => p.code === providerCode);
  const selectedProviderId = selectedProvider?.id;

  const { data: models = [] } = useGetAiModelsByProviderIdQuery(selectedProviderId, {
    skip: !selectedProviderId
  });
  const selectedModel = models.find((m) => m.code === modelCode);

  return (
    <BaseNode
      id={id}
      icon="record_voice_over"
      nodeData={{ ...data, label: msg({ id: 'field.longContextModel.label' }) }}
      color="error"
      handleConf={[
        { type: 'target', position: Position.Top, style: { background: 'orange' } },
        { type: 'target', position: Position.Left },
        { type: 'source', position: Position.Right }
      ]}
      key={`node-${id}-${providerCode}`}
      onEditNode={onEditNode}
      onDeleteNode={onDeleteNode}
    >
      <Stack spacing={1} sx={{ p: 1, width: '280px' }}>
        <CompactNodeField
          label={msg({ id: 'field.provider.label' })}
          value={selectedProvider ? selectedProvider.label : 'Aucun'}
        />
        <CompactNodeField
          label={msg({ id: 'field.model.label' })}
          value={selectedModel ? selectedModel.label : 'Aucun'}
        />

        <CompactNodeField label={msg({ id: 'field.outputvar.label' })} value={outputVar} />

        <FormControlLabel
          control={<Checkbox checked={!!data?.isStructuredOutput} disabled />}
          label={msg({ id: 'field.structuredOutput.label' })}
        />
      </Stack>
    </BaseNode>
  );
}

LongContextModelNode.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.number,
    providerCode: PropTypes.string,
    modelCode: PropTypes.string,
    outputVar: PropTypes.string,
    isStructuredOutput: PropTypes.bool,
    schema: PropTypes.object
  }),
  onEditNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired
};
